export const environment = {
    isProduction: true,
    clickkerWatcher: {
        api: {
            url: "https://api.watcher.clickker.nl/api"
        },
        webSocket: {
            url: "https://api.watcher.clickker.nl"
        }
    },
    clickkerCloud: {
        api: {
            url: "https://api.cloud.clickker.nl/api"
        },
        mvc: {
            url: "https://cloud.clickker.nl"
        }
    },
    clickkerAuth: {
        api: {
            url: "https://auth.clickker.nl"
        },
        login: {
            path: "authorization/login",
            clientId: "950ca3d4-6788-4799-bb5a-6fd6eef0b16c"
        },
        superTenantIds: [
            "08d9b999-3d0b-45f5-8154-ad9fb84cf707"
        ]
    }
};
